module.exports = __webpack_public_path__ + "media/Synchron_aufgebracht.04ea2988.mp3";